import { render, staticRenderFns } from "./justSlides.vue?vue&type=template&id=327a5ac2&scoped=true"
import script from "./justSlides.vue?vue&type=script&lang=js"
export * from "./justSlides.vue?vue&type=script&lang=js"
import style0 from "./justSlides.vue?vue&type=style&index=0&id=327a5ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327a5ac2",
  null
  
)

export default component.exports